import React from 'react';
import { Container } from '@deere/ux.uxframe-react';

export const EmptyStateLayout = ({context, message}) => (
    <Container fluid>
        <div className="justify-content-center text-center d-block" style={{'height' : '200px'}}>
            <h4 style={{ maxWidth: '28.125rem', marginTop: 100, marginLeft: 'auto', marginRight:'auto' }} >{context}</h4>
            <p className="d-block"
                style={{ maxWidth: '28.125rem', marginTop: 15, marginLeft: 'auto', marginRight:'auto' }}>
                {message}
            </p>
        </div>
    </Container>
);

